import React from 'react';
import { Button, Box, Stack, Typography } from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { AlertDialogContainer } from '../../../../../components/others/AlertDialogContainer';
import { submitSeasonAction } from '../../../../../services/request';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';

export const SeasonForm = props => {
  const { data, submitCallback, handleClose, allSeasons } = props;

  const { loading, mutate } = useMutation(submitSeasonAction);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

  const validationSchema = Yup.object({
    identifier: Yup.string().required('To pole nie może być puste'),
    year: Yup.number().required('To pole nie może być puste'),
    max_standard_promotions_per_season: Yup.number().required('To pole nie może być puste')
  });

  const initialValues = {
    identifier: data ? data.identifier || '' : '',
    year: data ? data.year || 2022 : 2022,
    season: data ? data.season || allSeasons[allSeasons.length - 1].value : allSeasons[allSeasons.length - 1].value,
    max_standard_promotions_per_season: data ? data.max_standard_promotions_per_season : 1
  };

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, data ? 'PUT' : 'POST', data ? data.identifier : undefined);
    if (!error) {
      submitCallback(payload, data ? 'edit' : 'created', 'success', data ? 'Zaktualizowano sezon' : 'Dodano nowy sezon', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle('Nie udało się dodać nowego sezonu');
      setMessage('');
      setShowAlert(true);
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', data.identifier);
    if (!error) {
      submitCallback(data, 'delete', 'success', 'Usunięto sezon', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle('Nie udało się usunąć sezonu');
      setMessage('');
      setShowAlert(true);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
        <Box display="flex" flexDirection="column" mt={1} p={1} ml="5%" mr="5%">
          {/* <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Identyfikator</Typography>
            <DebounceInput
              sx={{ flex: '1 1 90%' }}
              name="identifier"
              id="identifier"
              type="text"
              placeholder="identyfikator"
              value={formik.values.identifier}
              onChange={formik.handleChange}
              error={formik.touched.identifier && Boolean(formik.errors.identifier)}
              helperText={formik.touched.identifier && formik.errors.identifier}
              debounceTimeout={100}
              element={SmallFormTextField}
              autoFocus
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Rok</Typography>
            <DebounceInput
              sx={{ flex: '1 1 90%' }}
              name="year"
              id="year"
              type="number"
              placeholder="rok"
              value={formik.values.year}
              onChange={formik.handleChange}
              error={formik.touched.year && Boolean(formik.errors.year)}
              helperText={formik.touched.year && formik.errors.year}
              debounceTimeout={100}
              element={SmallFormTextField}
              autoFocus
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Sezon</Typography>
            <SmallFormTextField
              sx={{ flex: '1 1 90%' }}
              select
              id="season"
              name="season"
              options={allSeasons}
              value={formik.values.season}
              onChange={formik.handleChange}
            />
          </Stack> */}
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Maksymalna ilość promocji standardowych</Typography>
            <DebounceInput
              sx={{ flex: '1 1 90%' }}
              name="max_standard_promotions_per_season"
              id="max_standard_promotions_per_season"
              type="number"
              placeholder="maksymalna ilość promocji standardowych"
              value={formik.values.max_standard_promotions_per_season}
              onChange={formik.handleChange}
              error={formik.touched.max_standard_promotions_per_season && Boolean(formik.errors.max_standard_promotions_per_season)}
              helperText={formik.touched.max_standard_promotions_per_season && formik.errors.max_standard_promotions_per_season}
              debounceTimeout={100}
              element={SmallFormTextField}
              autoFocus
            />
          </Stack>
        </Box>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          <AddIcon />
          Zapisz
        </Button>

      </form>
      <ConfirmDialog
        title="Usunąć Zakwaterowanie?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
        disabled={loading}
      >
        Czy na pewno chcesz usunąć ten sezon?
      </ConfirmDialog>
    </>

  );
};
